import React, { FC } from "react";

import { useBoolean, useFooters, useCounter } from "~/hooks";

import { PostHeader, PostContent } from "~/components/organisms";

import {
  EmployeeConditionSubmissionReplyType,
  PostDetailMenuItemType,
} from "~/domains";

import { PostDetailWrapper } from "~/ui";

type PropsType = {
  employeeConditionSubmissionReply: EmployeeConditionSubmissionReplyType;
  menuItems: PostDetailMenuItemType[];
  isHighlight?: boolean;
};

export const EmployeeConditionSubmissionReplyDetail: FC<PropsType> = ({
  employeeConditionSubmissionReply,
  menuItems,
  isHighlight = false,
}: PropsType) => {
  const {
    isChecked: liked,
    setTrue: setLiked,
    setFalse: setNotLiked,
  } = useBoolean(employeeConditionSubmissionReply.liked);
  const {
    count: likeCount,
    increment: likeIncrement,
    decrement: likeDecrement,
  } = useCounter(employeeConditionSubmissionReply.likesCount);

  const handleCreateLike = () => {
    // TODO: Implement like functionality when API hooks are available
    setLiked();
    likeIncrement();
  };

  const handleDeleteLike = () => {
    // TODO: Implement unlike functionality when API hooks are available
    setNotLiked();
    likeDecrement();
  };

  const leftFooters = useFooters({
    like: {
      doneAlready: liked,
      undoOnClick: handleDeleteLike,
      doOnClick: handleCreateLike,
      textOnClick: () => {
        // TODO: Implement liked employees modal when available
      },
      count: likeCount,
    },
  });

  return (
    <PostDetailWrapper isHighlight={isHighlight}>
      <PostHeader
        miniText={employeeConditionSubmissionReply.createdAt}
        postedEmployee={employeeConditionSubmissionReply.employee}
        menuItems={menuItems}
      />
      <PostContent
        content={employeeConditionSubmissionReply.content}
        images={employeeConditionSubmissionReply.attachFiles}
        footers={leftFooters.footers}
        rightFooters={[]}
        className="mt-2 pl-16"
      />
    </PostDetailWrapper>
  );
};
